<template>
  <div class="popup-box flex flex-column" style="position: relative">
    <ul class="form-box">
      <el-form :model="state.model" ref="formDom" class="infoForm">
        <el-form-item label="状态">
          <el-switch
            v-model="state.model.status"
            inline-prompt
            active-text="正常"
            active-color="#1e90ff"
            inactive-text="停用"
            inactive-color="#f00"
            :active-value="1"
            :inactive-value="0"
            style="--el-switch-off-color: #f00"
          />
        </el-form-item>
        <el-form-item
          label="账户类型"
          prop="type"
          :rules="[
            {
              required: true,
              message: '请选择账户类型',
              trigger: 'blur',
            },
          ]"
        >
          <el-radio-group v-model="state.model.type">
            <el-radio :value="0" size="large">公司账户</el-radio>
            <el-radio :value="1" size="large">个人账户</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item
          label="户名"
          prop="name"
          :rules="[
            {
              required: true,
              message: '请填写户名',
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="state.model.name" />
        </el-form-item>

        <el-form-item
          label="银行"
          prop="bank"
          :rules="[
            {
              required: true,
              message: '请填写银行',
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="state.model.bank" />
        </el-form-item>
        <el-form-item
          label="开户行"
          prop="opening_bank"
          :rules="[
            {
              required: true,
              message: '请填写开户行',
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="state.model.opening_bank" />
        </el-form-item>
        <el-form-item
          label="账号"
          prop="bank_account"
          :rules="[
            {
              required: true,
              message: '请填写账号',
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="state.model.bank_account" autocomplete="off" />
        </el-form-item>
        <el-form-item label="发票类型">
          <el-select v-model="state.model.d_invoice_id">
            <el-option
              v-for="item in state.invoiceData"
              :key="item"
              :label="item.name"
              :value="item.id"
            />
            <template #footer>
              <el-button size="small" @click="onLoadInvoice()">
                刷新
              </el-button>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="开票方式">
          <el-select v-model="state.model.d_invoice_type_id">
            <el-option
              v-for="item in state.invoiceTypeData"
              :key="item"
              :label="item.name"
              :value="item.id"
            />
            <template #footer>
              <el-button size="small" @click="onLoadInvoiceType()">
                刷新
              </el-button>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="开票抬头">
          <el-input v-model="state.model.invoice_title" />
        </el-form-item>
        <el-form-item label="统一社会信用代码">
          <el-input v-model="state.model.unified_social_credit_identifier" />
        </el-form-item>
      </el-form>
    </ul>
    <ul class="submit-box">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { invoice_select, invoicetype_select } from "@/http/dictionary";
import {
  customer_subaccount_add,
  customer_subaccount_detail,
  customer_subaccount_edit,
} from "@/http/customer";
import { post_response } from "@/utils/qFormat";

export default {
  props: {
    id: Number,
    customer_id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        status: 1,
      },
    });
    onMounted(() => {
      onLoadInvoice();
      onLoadInvoiceType();

      if (props.id) {
        customer_subaccount_detail(props.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data.data;
            state.model.fieldsArr = JSON.parse(state.model.fields);
          }
        });
      }
    });

    const onLoadInvoice = () => {
      invoice_select().then((res) => {
        if (res.status == 200) state.invoiceData = res.data.data;
      });
    };

    const onLoadInvoiceType = () => {
      invoicetype_select().then((res) => {
        if (res.status == 200) state.invoiceTypeData = res.data.data;
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (props.id) {
            customer_subaccount_edit(state.model).then((res) => {
              post_response(res, emit);
            });
          } else {
            state.model.customer_id = props.customer_id;
            customer_subaccount_add(state.model).then((res) => {
              post_response(res, emit);
            });
          }
        }
      });
    };
    return {
      state,
      props,
      formDom,
      onLoadInvoice,
      onLoadInvoiceType,
      onSubmit,
    };
  },
};
</script>
<style scoped lang="less"></style>
